import { z } from 'zod';

// ============================================================================
// AI Models
// ============================================================================

/**
 * Model names that we used in the past that we need to keep around for backwards compatibility.
 */
export const unusedAiModelNameSchema = z.union([
  z.literal('claude45Haiku'),
  z.literal('openai6Sol'),
  z.literal('claude5Sonnet'),
  z.literal('claude5Opus'),
  z.literal('gemini37Flash'),
  z.literal('openai56Sol'),
  z.literal('openai56Terra'),
  z.literal('openai56Luna'),
  z.literal('openai55'),
  z.literal('openai54Mini'),
  z.literal('openai54Nano'),

  z.literal('claude4Sonnet'),
  z.literal('claude37Sonnet'),
  z.literal('claude45Sonnet'),
  z.literal('claude46Sonnet'),
  z.literal('claude46Opus'),
  z.literal('claude47Opus'),
  z.literal('claude48Opus'),
  /**
   * Anthropic gates Claude Fable 5 behind a 30-day data-retention requirement
   * that our zero-data-retention org does not meet, so requests to it fail
   * with `model_not_available`. Kept here rather than deleted because stored
   * token-usage rows reference the alias.
   */
  z.literal('claude5Fable'),
  z.literal('gemini3Pro'),
  z.literal('gemini25Flash'),
  z.literal('gemini25FlashLite'),
  z.literal('gemini31FlashLite'),
  z.literal('gemini35Flash'),
  z.literal('gemini36Flash'),
  z.literal('openai4o'),
  z.literal('openai4omini'),
  z.literal('openai41'),
  z.literal('openai41Mini'),
  z.literal('openai51'),
  z.literal('openai52'),
  z.literal('openai54'),
  z.literal('openai5Mini'),
  z.literal('openaio1'),
  z.literal('openaio3'),
  z.literal('openaio3Mini'),
  z.literal('openai5'),
]);

/**
 * Model names that the catalog supports. May be used primarily, as a fallback,
 * or available for future use even if no caller references them yet.
 */
export const usedAiModelNameSchema = z.union([
  z.literal('claude55Opus'),
  z.literal('openai61Sol'),
  z.literal('openai6Luna'),
  z.literal('openai6Astra'),
  z.literal('gemini38Flash'),

  z.literal('claude55Haiku'),
  z.literal('claude55Sonnet'),
  z.literal('gemini35FlashLite'),
  z.literal('gemini25Pro'),
]);
export type UsedAiModel = z.infer<typeof usedAiModelNameSchema>;

export const legacyUnknownAiModelKey = 'legacyUnknown' as const;
export const aiModelNameSchema = z.union([unusedAiModelNameSchema, usedAiModelNameSchema]);
export type AiModel = z.infer<typeof aiModelNameSchema>;
export type AiTokenUsageModelKey = AiModel | typeof legacyUnknownAiModelKey;
